import 'simplebar-react/dist/simplebar.min.css';

import { Box } from '@chakra-ui/react';
import { gridConfig } from '@time-line/components/common';
import type { Props } from 'simplebar-react';
import SimpleBar from 'simplebar-react';

const { gridPxClamp } = gridConfig;

export function TimelineScrollbar(props: Props) {
  return (
    <Box
      sx={{
        height: '100%',
        '.simplebar-scrollable-x': {
          height: '100%',
          pl: gridPxClamp,
          pb: 'm',
        },
        '.simplebar-content': {
          height: '100%',
        },
        '.simplebar-track': {
          height: '2xs',
          left: gridPxClamp,
          right: gridPxClamp,
          bg: 'blackAlpha.250',
          borderRadius: '2xl',
        },
        '.simplebar-scrollbar:before': {
          bg: 'gray.50',
          opacity: 1,
          top: '4px',
          right: '4px',
          left: '4px',
          bottom: '4px',
        },
      }}
    >
      <SimpleBar forceVisible="x" {...props} />
    </Box>
  );
}
